import { useContext } from 'react';
import SectionContext from '../../SectionContext';
import GroupsManager from '../../GroupsManager';
import ModelsContext from '../../../../ModelsContext';
import useApi from '@/lib/api/useApi';
import PortfolioItemWithGroupsPromptVariant from '@/pages/EditorPage/RubricsPortfolioTemplatesEditor/PortfolioTemplatesEditor/PortfolioItemWithGroupsPrompt/PortfolioItemWithGroupsPromptVariant.enum';
import { type EditorSectionWithoutRelations } from '@/lib/types';
import SelectedModelIdContext from '../../../../SelectedModelIdContext';

const SectionGroups = () => {
  const api = useApi();

  const [, setModels] = useContext(ModelsContext);
  const selectedModelId = useContext(SelectedModelIdContext);
  const { section } = useContext(SectionContext);

  const saveGroups = async (groups: number[]): Promise<void> => {
    const updatedSection = await api.put<EditorSectionWithoutRelations>(
      `editor/challenge-model/sections/${section.id}/groups`,
      {
        groups,
      },
    );

    setModels(models => {
      models[selectedModelId].sections[section.id] = {
        ...models[selectedModelId].sections[section.id],
        ...updatedSection,
        groups: groups.map(id => ({ id })),
      };
    });
  };

  return (
    <GroupsManager
      variant={PortfolioItemWithGroupsPromptVariant.SECTION}
      selectedGroups={section.groups.map(({ id }) => id)}
      onSave={saveGroups}
    />
  );
};

export default SectionGroups;
